import {
	CustomDetailEnum,
	DocumentWorkflowTemplateVisibleIn,
	KycFormTemplateRes,
} from '@dealstack/shared/lib/generated';

export const formatTemplateForForm = (template: KycFormTemplateRes) => ({
	id: template.id,
	fileId: template.fileId,
	fileName: template.fileName,
	name: template.name,
	instruction: template.instruction || '',
	type: template.visibleIn.includes(DocumentWorkflowTemplateVisibleIn.KYC_VEHICLE)
		? CustomDetailEnum.VEHICLE
		: CustomDetailEnum.INDIVIDUAL,
	category: template.category,
	archived: template.archived,
	isPreFillable: template.isPreFillable,
	requiresSignature: template.requiresSignature,
	useManualSignaturePlacement: template.useManualSignaturePlacement,
	showStampMetadata: template.showStampMetadata,
	sourceFormat: template.sourceFormat,
});
